// extracted by mini-css-extract-plugin
export default {"trading":"TradingPage_trading__vXSdM"};